import React from 'react';
import { useTranslation } from 'react-i18next';
import FormikSelect from '../../../base/forms/formikSelect';
import { A, P } from '../../../base/typography';
import UploadFiles from '../../../uploadFiles';
import { useMultiStepFormContext } from '../../context/multistepContext';
import { useTranslationsContext } from '../../context/translationsContext';
import { FormStepProps } from '../../sendReceiptMultistep';
import {
	ButtonWrapper,
	ErrorMessage,
	FormStepHeading,
	Label,
	PrevButton,
	PrevButtonMobile,
	ProceedButton,
} from '../../sendReceiptMultistep.styles';
import { INSTRUCTIONS_TO_STAFF_STEP_INDEX, SEPARATOR_CHAR } from './InstructionToStaff';
import * as StyledType from './InstructionToStaff.styles';

const GIFT_OPTIONS = ['birthday', 'graduation', 'confirmationOrBaptise', 'wedding', 'christmas', 'otherGift'];
const GIFT_OPTIONS_MAX_LENGTH = Math.max(...GIFT_OPTIONS.map(option => option.length));

export default function Gift({ touched, errors, values, setFieldValue }: FormStepProps) {
	const translations = useTranslationsContext();
	const { next, prev } = useMultiStepFormContext();
	const { t } = useTranslation('sendReceiptMultistep');

	const isStepComplete = values.giftType?.value && !errors.giftType && !errors.additionalInformation && !errors.files;

	return (
		<>
			<PrevButtonMobile
				onClick={e => {
					e.stopPropagation();
					prev();
				}}
				>
				{translations?.prevStepMobile || t('prevStepMobile')}
			</PrevButtonMobile>
			<FormStepHeading>
				{translations?.formStepTitles?.type?.gift || t('formStepTitles.type.gift')}
			</FormStepHeading>
			<P>{translations?.gift?.explanation || t('gift.explanation')}</P>
			<Label>{translations?.gift?.selectText || t('gift.selectText')}</Label>
			<FormikSelect
				id="giftType"
				options={[
					{
						label: translations?.gift?.giftType?.birthday || t('gift.giftType.birthday'),
						value: GIFT_OPTIONS[0],
					},
					{
						label: translations?.gift?.giftType?.graduation || t('gift.giftType.graduation'),
						value: GIFT_OPTIONS[1],
					},
					{
						label:
							translations?.gift?.giftType?.confirmationOrBaptise ||
							t('gift.giftType.confirmationOrBaptise'),
						value: GIFT_OPTIONS[2],
					},
					{
						label: translations?.gift?.giftType?.wedding || t('gift.giftType.wedding'),
						value: GIFT_OPTIONS[3],
					},
					{
						label: translations?.gift?.giftType?.christmas || t('gift.giftType.christmas'),
						value: GIFT_OPTIONS[4],
					},
					{ label: translations?.gift?.giftType?.other || t('gift.giftType.other'), value: GIFT_OPTIONS[5] },
				]}
				onChange={setFieldValue}
				onBlur={() => {}}
				name="giftType"
				value={values.giftType}
				placeholder={translations?.gift?.selectPlaceholder || t('gift.selectPlaceholder')}
			/>
			<P marginTop="2rem">{translations?.validReceipt || t('validReceipt')}</P>
			<Label marginBottom="2rem">{translations?.sendAFile || t('sendAFile')}</Label>
			<UploadFiles name="files" />
			<Label marginTop="2rem">{translations?.description || t('description')}</Label>
			<StyledType.TextArea
				maxLength={254 - GIFT_OPTIONS_MAX_LENGTH - SEPARATOR_CHAR.length}
				type="text"
				id="additionalInformation"
				name="additionalInformation"
				component="textarea"
				padding="1rem"
				placeholder={`${translations?.descriptionPlaceholder || t('descriptionPlaceholder')}`}
			/>
			{touched.additionalInformation && errors.additionalInformation && (
				<ErrorMessage>
					{translations?.recipient?.errors?.[errors.additionalInformation] ||
						t(`recipient.errors.${errors.additionalInformation}`)}
				</ErrorMessage>
			)}
			<P marginTop="2rem">
				{translations?.gift?.furtherInfo || t('gift.furtherInfo')}
				<A blank to={translations?.gift?.furtherInfoUrl || t('gift.furtherInfoUrl')}>
					{translations?.gift?.furtherInfoLinkText || t('gift.furtherInfoLinkText')}
				</A>
			</P>
			<ButtonWrapper>
				<PrevButton
					onClick={e => {
						e.stopPropagation();
						prev();
					}}
					>
					{translations?.prevStep || t('prevStep')}
				</PrevButton>
				<ProceedButton
					type="button"
					onClick={e => {
						e.stopPropagation();
						next();
					}}
					disabled={!isStepComplete}>
					{translations?.nextStep || t('nextStep')}
				</ProceedButton>
			</ButtonWrapper>
		</>
	);
}
